import React from 'react';
import {
  FDTableHead, FDTableRow, FDTableCell,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const PlannerTransitionTableHead = ({ plannerTransitionCollection }) => {
  return (
    <FDTableHead>
      <FDTableRow>
        {plannerTransitionCollection.meta().template().list().filter(field => !field.attr('hidden'))
          .map((field) => {
            return (<FDTableCell key={field.attr('name')}> {field.attr('prompt')} </FDTableCell>);
          })}
      </FDTableRow>
    </FDTableHead>
  );
};

PlannerTransitionTableHead.defaultProps = {
};

PlannerTransitionTableHead.propTypes = {
  plannerTransitionCollection: PropTypes.object.isRequired,
};

export default PlannerTransitionTableHead;
